var _path, _path2, _path3, _path4, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path5, _circle, _circle2, _circle3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 303,
    height: 140,
    viewBox: "0 0 303 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M292.031 55.7812H302.969",
    stroke: "#11A75C",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M297.5 51.4062V61.25",
    stroke: "#11A75C",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M217.656 98.4375C211.251 93.8211 214.987 84.1182 217.656 79.8438H154.219V98.4375H217.656Z",
    fill: "#C9FFE4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M181.209 24.0625C182.676 18.8125 180.597 15.3125 179.375 14.2188H200.156C197.711 18.9437 199.138 22.75 200.156 24.0625H181.209Z",
    fill: "#C9FFE4"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 166.25,
    width: 55.7812,
    height: 14.2188,
    rx: 6.5,
    fill: "#C9FFE4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 226.406,
    y: 4.375,
    width: 20.7812,
    height: 14.2188,
    rx: 6.5,
    fill: "#C9FFE4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 281.094,
    y: 72.1875,
    width: 19.6875,
    height: 10.9375,
    rx: 5.46875,
    fill: "#C9FFE4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 169.531,
    y: 24.0625,
    width: 72.1875,
    height: 15.3125,
    rx: 7,
    fill: "#C9FFE4"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 85.3125,
    y: 65.625,
    width: 183.75,
    height: 14.2188,
    rx: 6.5,
    fill: "#C9FFE4"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 32.8125,
    y: 98.4375,
    width: 216.562,
    height: 14.2188,
    rx: 6.5,
    fill: "#C9FFE4"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    y: 125.781,
    width: 166.25,
    height: 14.2188,
    rx: 6.5,
    fill: "#C9FFE4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6875 125.781C61.4291 121.056 57.4965 115.062 54.6875 112.656H144.375V125.781H54.6875Z",
    fill: "#C9FFE4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 107.188,
    cy: 22.9688,
    r: 6.65625,
    stroke: "#11A75C",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 228.594,
    cy: 129.062,
    r: 5.5625,
    stroke: "#11A75C",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 152.031,
    cy: 91.875,
    r: 48.125,
    fill: "#11A75C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_58361_7292)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.792 48.1357H153.969C155.448 48.32 156.949 48.4554 158.404 48.6993C167.635 50.2436 175.679 54.2154 182.298 60.8288C192.227 70.7502 196.597 82.8093 195.327 96.773C194.476 106.147 190.807 114.432 184.538 121.471C176.215 130.81 165.73 135.846 153.238 136.459C144.519 136.884 136.324 134.852 128.854 130.301C117.383 123.305 110.344 113.17 107.868 99.9293C107.556 98.274 107.405 96.5861 107.18 94.9144V89.7288L107.391 87.8676C108.448 78.3552 112.081 69.9672 118.499 62.8553C125.305 55.3018 133.736 50.5877 143.769 48.8131C145.432 48.5178 147.117 48.3498 148.792 48.1357ZM144.508 99.6124C144.324 99.4552 144.17 99.3414 144.023 99.2005C141.84 97.1975 139.655 95.1962 137.47 93.1967C135.749 91.6254 134.086 89.9835 132.27 88.5286C129.651 86.4316 125.825 88.087 125.429 91.414C125.226 93.0965 125.909 94.4186 127.134 95.5322C131.884 99.8453 136.627 104.164 141.363 108.488C143.674 110.593 145.996 110.558 148.204 108.366L175.644 81.1295C175.887 80.8857 176.129 80.6392 176.348 80.3736C176.766 79.8771 177.069 79.2946 177.236 78.6675C177.403 78.0405 177.429 77.3843 177.314 76.7458C177.198 76.1073 176.943 75.5022 176.567 74.9735C176.19 74.4448 175.702 74.0056 175.137 73.6871C173.24 72.6034 171.206 72.9556 169.447 74.7221C161.368 82.7939 153.292 90.8686 145.218 98.9459C144.991 99.1491 144.763 99.3577 144.508 99.5961V99.6124Z",
    fill: "#E9FFF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.508 99.5961C144.763 99.3577 144.99 99.1491 145.21 98.9296C153.287 90.8523 161.363 82.7777 169.439 74.7058C171.205 72.9394 173.232 72.579 175.128 73.6709C175.694 73.9894 176.182 74.4286 176.558 74.9573C176.934 75.486 177.189 76.0911 177.305 76.7296C177.421 77.3681 177.394 78.0242 177.227 78.6513C177.06 79.2784 176.757 79.8609 176.339 80.3574C176.12 80.6284 175.879 80.8695 175.635 81.1133L148.203 108.35C145.995 110.542 143.673 110.577 141.362 108.472C136.621 104.15 131.878 99.8309 127.133 95.5159C125.909 94.4024 125.237 93.0776 125.429 91.3978C125.825 88.0708 129.65 86.4154 132.27 88.5124C134.085 89.9673 135.749 91.6091 137.469 93.1805C139.658 95.1673 141.843 97.1686 144.023 99.1843C144.169 99.3171 144.326 99.439 144.508 99.5961Z",
    fill: "#11A75C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_58361_7292"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 88.3555,
    height: 88.3853,
    fill: "white",
    transform: "translate(107.188 48.125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/Success.7e3047ecb3fcbd9d3b223e04d1d790bc.svg";
export { ForwardRef as ReactComponent };